<template>
  <v-card dark>
    <v-card-text class="relative">
      
      
      
      
      <h3 class="title mb-2 white--text"># {{item.doc.hashtag}}</h3>
      <div class="overline mb-4">Activation Idea</div>
      <h3 class="subtitle-2">Concept</h3>
      <p class="body-1 white--text" v-html="item.doc.concept"></p>
      <h3 class="subtitle-2">One liner</h3>
      <p class="body-1 white--text" v-html="item.doc.sentence"></p>
    </v-card-text>

    <v-card-actions>
      <v-btn class="service__card__edit" @click="editNote(item.id)">
        Edit
      </v-btn>
      <v-btn class="service__card__edit" @click="showNote(item.id)">
        Expand
      </v-btn>
      <!-- <v-btn class="service__card__edit" @click="deleteNote(item.id)">
        Delete
      </v-btn> -->
    </v-card-actions>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "UserTravelCard",
  data() {
    return {
      open: false,
      selected: false
    };
  },
  watch: {
    TravelStar(val) {
      if (val) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    }
  },
  mounted() {
    if (this.TravelStar) {
        this.selected = true;
      } else {
        this.selected = false;
     }
  },
  props: {
    item: Object,
    all: Array,
    selectedItems: Array
  },
  methods: {
    editNote(id) {
      this.$emit("editNote", id);
    },
    showNote(id) {
      this.$emit("showNote", id);
    },
    deleteNote(id) {
      this.$emit("deleteNote", id);
    },
    select(id) {
      this.selected = !this.selected;
      this.$emit("selectNote", id, this.selected);
    }
  },
};
</script>

<style lang="scss">
  .star {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #ffc107;
    &--Travel {
      color: #ffc107;
    }
  }

</style>